import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

const PASSWORD_TEXT_REQUIREMENTS = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 99;

/**
 * Get the options for `react-hook-form`'s `register()` for password validation.
 *
 * @example
 * ```tsx
 *   const { register } = useForm();
 *   const passwordValidation = usePasswordValidationConfigurations();
 *
 *   return (
 *     <Input type="password" {...register('password', passwordValidation)} />
 *   );
 * ```
 */
export function usePasswordValidationConfigurations() {
  const t = useTranslations('auth.password');
  return useMemo(
    () => ({
      required: t('password_required'),
      minLength: {
        value: PASSWORD_MIN_LENGTH,
        message: t('password_min_length'),
      },
      maxLength: {
        value: PASSWORD_MAX_LENGTH,
        message: t('password_max_length'),
      },
      pattern: {
        value: PASSWORD_TEXT_REQUIREMENTS,
        message: t('purchase_password_text_requirements'),
      },
      invalid: {
        value: true,
        message: t('invalid_password'),
      },
    }),
    [t],
  );
}
